import CREAR_ACTIVIDAD from '@/graphql/mutations/administracion/actividades/crearActividad.gql';
import REMOVER_ACTIVIDAD from '@/graphql/mutations/administracion/actividades/removerActividad.gql';
import ACTUALIZAR_ACTIVIDAD from '@/graphql/mutations/administracion/actividades/actualizarActividad.gql';
import ACTIVIDADES from '@/graphql/querys/administracion/actividades/actividades.gql';

export default {
  methods: {
    // Agregar actividad
    async mixCrearActividad() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: CREAR_ACTIVIDAD,
        variables: {
          actividad: this.actividad,
        },
        update: (store, { data: { crearActividad } }) => {
          const query = {
            query: ACTIVIDADES,
            variables: {
              idReferencia: this.idReferenciaActividad,
            },
          };
          const { actividades } = store.readQuery(query);
          const actividadesCopia = actividades.slice();
          actividadesCopia.push(crearActividad);
          store.writeQuery({
            ...query,
            data: {
              actividades: actividadesCopia,
            },
          });
        },
      })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Editar actividad
    async mixActualizarActividad() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_ACTIVIDAD,
        variables: {
          id: this.actividadEditar.id,
          actividad: this.actividad,
        },
        update: (store, { data: { actualizarActividad } }) => {
          const query = {
            query: ACTIVIDADES,
            variables: {
              idReferencia: this.actividadEditar.idReferencia,
            },
          };
          const data = store.readQuery(query);
          const { actividades } = data;
          const index = actividades
            .findIndex((actividad) => actividad.id
            === actualizarActividad.id);
          if (index !== -1) {
            actividades.splice(index, 1, actualizarActividad);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar actividad
    async mixEliminarActividad() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_ACTIVIDAD,
        variables: {
          id: this.actividadEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({
            query: ACTIVIDADES,
            variables: {
              idReferencia: this.idReferencia,
            },
          });
          const { actividades } = data;
          const index = actividades
            .findIndex((actividad) => actividad.id === this.actividadEliminar.id);
          if (index !== -1) {
            actividades.splice(index, 1);
          }
          store.writeQuery({ query: ACTIVIDADES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },

};
